
import { Model } from 'backbone';
import BasePropertyView from 'BasePropertyView';
import Template from 'behaviors/properties/main/exit.ejs';
import constants from 'Constants';
import listService from 'ListService';
import SelectFieldModal from 'common-views/SelectFieldModalView';
import MainFormulaModal from 'common-views/MainFormulaModalView.js';
import util from 'util/Util.js';

//=====================================================================
//
// An instance of this view represents an exit.
//
// Casey Justus, May 13, 2016
// Lou Mauget, 2017-12-8
//
// Notes:
//
// EXAMPLE OF EXIT BEHAVIOR PARAMETERS when type="expression".
// Note that this exitCommand has settings for all type values from set: 'literal', 'field', 'special', or 'expression'.
// Command property's type value dictates which parameter is active
//
// <Command id="spPGOwAAqW4AAHW9AAAfXu96zWU=" type="exitcommand">
//     <Properties cancelEvent="true" x="249" height="30" width="30" y="60" />
//     <Parameters>
//         <Parameter id="default" type="expression" literal="nnnnnnnnnnn" field="PFXX6344268076426461184" special="formurl">
//             <Expression id="qxLnZQAAPdQAAEC6AAD8knbnM0Q=" type="scriptingParameter">
//                  <Argument id="Z0YvEgAAxRsAAH0XAAB0Wvw07Z8=" type="scripting_literal" value="111" />
//                  <Operator id="adubQgAAoxkAAJwnAAB0BAh7Z+A=" type="+" />
//                  <Argument id="Sp3UTAAABg0AAEQWAADXbgh6ygw=" type="scripting_literal" value="" />
//                  <Operator id="hev5NAAArnYAAPdIAACYGzvwmVg=" type="+" />
//                  <Function id="uSaBsQAAIJMAABpeAAA6YluM7bc=" type="script_floor">
//                      <Argument id="SUPFWQAArycAAN2nAACSd1uMSZE=" type="scripting_literal" value="" />
//                  </Function>
//             </Expression>
//         </Parameter>
//     </Parameters>
// </Command>
//
//=====================================================================

class MainExitView extends BasePropertyView {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change select'                 : 'updateAttributes',
            'change input[type=radio]'      : 'updateAttributes',
            'change input[type=text]'       : 'updateAttributes',
            'blur input[type=text]'         : 'lostFocus',
            'focus input[type=text]'        : 'getFocus',
            'change input[type=checkbox]'   : 'updateCheckAttributes',
            'click :button[name=fieldSelectButton]'    : 'showFieldDialog',
            'click :button[name=formulaComposeButton]' : 'showFormulaDialog'
        };


        // Init radio buttons
        if (!this.model.get('redirectType')) {
            this.model.set({
                textOrNumberReadOnly: '', // Pre-enabled. It will flip to readonly when another state selected
                specialDisabled: 'disabled',
                fieldValueDisabled: 'disabled',
                formulaValueDisabled: 'disabled'
            }, { silent: true });

            this.model.set( {redirectType: 'textOrNumber'}, {silent: false});
        }


        if (!this.model.has('Parameters')) {
            this.emitBoilerplateParameters(this.model);
        }

        console.log(`Model attributes`, this.model.attributes);

        this.listenTo(this.model, 'change', this.render);

        return this;
    }


    emitBoilerplateParameters(model) {
        // Boilerplate baby steps:
        // type is a form object property.
        // type value is from set: 'literal', 'field', 'special', or 'expression' (each is a redirectType)
        const
            parameters = {Parameter: []},
            parameter = parameters['Parameter'],
            p = {};

        parameter.push(p);

        p.id = 'default';
        p.type ='literal';
        p.literal = 'placeholder';
        p.field = 'null';
        p.special = 'stage';

        model.set('Parameters', parameters);
    }


    updateAttributes(ev) {
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));

        this.model.set( propName, propVal );

        // textOrNumber goes to parameter.literal, special goes to parameter.special, and fieldValue goes to parameter.field
        // Expression/formuala not rendered except in MainFormulaModal popup
        if ('textOrNumber' === propName) {
            this.model.attributes.Parameters.Parameter[0].type = 'literal';
            this.model.attributes.Parameters.Parameter[0].literal = propVal;
        } else  if ('special' === propName) {
            this.model.attributes.Parameters.Parameter[0].type = 'special';
            this.model.attributes.Parameters.Parameter[0].special = propVal;
        } if ('fieldValue' === propName) {
            this.model.attributes.Parameters.Parameter[0].type = 'field';
            this.model.attributes.Parameters.Parameter[0].field = propVal;
        }

        this.redirectStateContoller();

        this.render();
    }

    // This sets state based one user input envets.
    // The state is presented in _renderState during the render phase.
    redirectStateContoller() {
        // Disable these so we can possibly enable one of them.
        this.model.set({
            textOrNumberReadOnly: 'readonly',
            specialDisabled: 'disabled',
            fieldValueDisabled: 'disabled',
            formulaValueDisabled: 'disabled'
        }, { silent: true });

        // redirectType is the selected radiobutton value
        const redirectType = this.model.get('redirectType');
        //console.log(`redirectType`, redirectType );

        if (redirectType === 'textOrNumber') {
            this.model.set({textOrNumberReadOnly: ''}, {silent: true});
        }
        else if (redirectType === 'special') {
            this.model.set({specialDisabled: ''}, {silent: true});
        }
        else if (redirectType === 'fieldValue') {
            this.model.set({fieldValueDisabled: ''}, {silent: true});
        }
        else if (redirectType === 'formulaValue') {
            this.model.set({formulaValueDisabled: ''}, {silent: true});
        }
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        const newValue = propVal ? 'true' : 'false';
        // let newValue = "";
        // if (propVal) {
        //     newValue = "checked";
        // }
        this.model.set( propName, newValue );
    }

    isOnReport() {
        return listService.docType === constants.DOC_TYPE_REPORT
    }

    showFieldDialog(ev){
        ev.preventDefault();
        
        var sfModel = new Model();
        sfModel.set("dataSelectedItemId", this.model.get('fieldId'), {silent:true});
        
        const sfModal = new SelectFieldModal({model: sfModel});
        sfModal.render().then((selectedField)=>{
            // used only for display in the UI
            this.model.set('fieldValue', selectedField.name, {silent: true});
            this.model.set('fieldId', selectedField.id, {silent: true});//this line was commented for the PF-1185
            this.render();
        });
    }

    showFormulaDialog(ev) {
        ev.preventDefault();

        const expression = this.model.attributes.Parameters.Parameter[0].Expression;

        const dlgModel = new Model();

        dlgModel.set('formulaParameter', expression, {silent:true});
        dlgModel.set('title', 'Compose Formula', {silent:true});

        const sfModal = new MainFormulaModal({model: dlgModel, config: {selected: ''}});
        sfModal.render().then( formulaParameter => {
            // Set the MainExitView model:
            this.model.attributes.Parameters.Parameter[0].Expression = formulaParameter;
            console.log(`formula`, this.model.attributes.Parameters.Parameter[0].Expression = formulaParameter);
        }).catch(err => {
            console.log(err)
        });
    }

    _renderState(model) {
        $(`input:radio[value='${model.get('afterSubmission')}']`).attr('checked', true);
        $(`input:radio[value='${model.get('redirectType')}']`).attr('checked', true);

        $(`input:checkbox[name=cancelEvent]`).attr('checked', model.get('cancelEvent') === 'true');

        $(`option[value='${model.get('special')}']`).attr('selected', true);

        $(`:button[name="fieldSelectButton"]`).attr('disabled', model.get('fieldValueDisabled') === 'disabled');
        $(`:button[name="formulaComposeButton"]`).attr('disabled', model.get('formulaValueDisabled') === 'disabled');
    }

    render() {
        // Save isReport (should be in parent)
        this.model.set('isReport', this.isOnReport(), { silent: true });
        
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this._renderState(this.model);

        this.delegateEvents();
        return this;
    }

}

export default MainExitView;
